import successPhone from 'images/landingpages/big-direct/screens.png';
import mobilePhone from 'images/landingpages/big-direct/antistress-coaching-course@2x.png';
import logoHeader from 'images/landingpages/big-direct/logo-big-direct.svg';

export const successPhoneImage = successPhone;
export const mobilePhoneImage = mobilePhone;
export const logoHeaderImage = logoHeader;
